import React from 'react'

export function ConnectWallet() {
  return (
    <div
      style={{
        width: '100%',
        height: 'auto',
        textAlign: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
      className="page"
    >
      <div>
        <h2 style={{ margin: 'auto' }}>Please connect your wallet</h2>
      </div>
    </div>
  )
}
